import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SemestersService } from '../../../inputfileds/form_services/semesters/semesters.service';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddsubjectsComponent } from './addsubjects/addsubjects.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { environment } from '../../../../environments/environment.prod';
import { AddsemestersComponent } from './addsemesters/addsemesters.component';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

export interface SemesterView {
  index: number;
  id: number;
  organization_id: number;
  course_name: string;
  course_code: string;
  department_name: string;
  number_of_semisters: number;
  description: string;
}

@Component({
    selector: 'app-semesters',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatMenuModule,
        MatTableModule,
        MatIconModule,
        RouterModule,
        MatButtonModule,
        MatInputModule,
        ReactiveFormsModule,
        MatExpansionModule,
        CommonModule,
        MatTabsModule,
        MatDividerModule,
        TranslateDirective
    ],
    providers: [QuestionControlService, ApiservicesService, SemestersService],
    templateUrl: './semesters.component.html',
    styleUrl: './semesters.component.scss'
})
export class SemestersComponent {
  CourseData: any;
  semesterData: any;
  selected_semesterData: any;
  semestesubjectsData: any;
  dataSource = new MatTableDataSource<SemesterView>();
  step = 0;
  @Input() subjects: any[] = [];
  onerror = 'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg';
  editsubjectdata: any = null;
  isSubjectEnabled = false;
  assetUrl: string = environment.ASSET_URL;
  assetContainer: string = environment.ASSET_CONTAINER;
  routedata : any;

  constructor(
    private router: Router,
    private apiservice: ApiservicesService,
    private dataService: SemestersService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public route: ActivatedRoute
  ) { 
  }

  ngOnInit(): void {
    this.routedata = this.route.snapshot?.queryParams['data'];
    this.getCoursedetails()
    this.getsemesterDetails();
  }

  getCoursedetails(){
    this.apiservice.getrespectivecoursesdata(this.routedata).subscribe((res) => {
      this.CourseData = res;
    // this.getsemesterDetails();
    });
  }
  
  getsemesterDetails(): void {
    const data = {
      "course_ID": this.routedata,
    }
    this.apiservice.getcoursewisesemester(data).subscribe((res: any) => {
      this.semesterData = res?.rows;
    })
  }

  getsemestersubjectsDetails(eventData: any): void {
    const data = {
      "semester_ID": eventData.id,
      "course_ID": eventData.course_id
    }
    this.apiservice.getsemestersclasssubjectsDetails(data).subscribe((res: any) => {
      this.semestesubjectsData = res?.rows;
    })
  }

  setStep(index: number, semester: any) {
    this.step = index;
    this.selected_semesterData = semester;
    this.getsemestersubjectsDetails(semester)
  }

  sendData(): void {
    this.dataService.setData(this.semesterData);
  }

  openAddSemisterDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated','animate__fadeIn'];
    dialogConfig.minWidth = '80%' ;
    dialogConfig.minHeight = '65vh';
    dialogConfig.maxHeight = 'auto';
    dialogConfig.data = this.CourseData;
    const dialogRef = this.dialog.open(AddsemestersComponent, dialogConfig);
    
    dialogRef.afterClosed().subscribe((result:any) => {
        this.getCoursedetails();
        this.getsemesterDetails();
    });
  }

  openSubjects(event?: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__fadeIn'];
    dialogConfig.minWidth = '30vw';
    dialogConfig.maxWidth = '30vw';
    dialogConfig.minHeight = '20vh';
    dialogConfig.maxHeight = '65vh';
    const dialogRef = this.dialog.open(AddsubjectsComponent,
      {
        minWidth: '40vw', 
        maxWidth: '40vw', 
        minHeight: '15vh', 
        maxHeight: '65vh',
        data: { semesterData: this.selected_semesterData, editdata: event }
      });
    dialogRef.afterClosed().subscribe(result => {
      this.editsubjectdata = null;
      this.getsemestersubjectsDetails(this.selected_semesterData)
    });
  }
  
  toggleSubjectState(subject: any) {
    const newStatus = subject.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    const newData = {
      ACTION: newStatus === 'ACTIVE' ? 'ENABLE' : 'DISABLE'
    };
  
    this.apiservice.subjectStatus(subject.id, newData).subscribe(
      (response: any) => {
        this._snackBar.open(`SUCCESSFULLY ${newData.ACTION}D` ,'', {
          duration: 3000
        });
        subject.status = newStatus;
      },
      (error: any) => {
        console.error('PATCH API Error:', error);
      }
    );
  }

  toggleCoursesState(course: any) {
    const newStatus = course.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    const newData = {
      ACTION: newStatus === 'ACTIVE' ? 'ENABLE' : 'DISABLE'
    };
  
    this.apiservice.courseStatus(course.id, newData).subscribe(
      (response: any) => {
        this._snackBar.open(`SUCCESSFULLY ${newData.ACTION}D`,"", {
          duration: 3000
        });
        course.status = newStatus;
      },
      (error: any) => {
        console.error('PATCH API Error:', error);
        // Handle error if needed
      }
    );
  }

  editsubjects(editevent : any){
    this.editsubjectdata = editevent;
    this.openSubjects(editevent)
  }

  showCourses(): void {
    this.router.navigate(['/courses']).then(() => {
      this.CourseData;
    });
  }
  

  csvInputChange(fileInputEvent: any) {
    this.uploaddata(fileInputEvent.target.files[0])
  }

  uploaddata(event: any) {
    this.apiservice.bulkuploadsubjects(event).subscribe(res => {
      this.getsemesterDetails();
    })
  }
}
